class WhatsAppCart {

  constructor() {
    this.phoneNumber = "918865888811";
    this.shopName = "Oh My Pets";
  }

  async fetchCart() {

    try {

      const response = await fetch('/cart.js');
      return await response.json();

    } catch (error) {

      console.error('Cart fetch failed:', error);
      return null;

    }

  }

  formatMoney(cents) {
    return `₹${(cents / 100).toFixed(0)}`;
  }

  async generateMessage(cart) {

  let message = `Hi, `;
  message += `I would like to place an order:\n\n`;

  let totalSavings = 0;

  for (const [index, item] of cart.items.entries()) {

    const variant =
      item.variant_title &&
      item.variant_title !== "Default Title"
        ? ` (${item.variant_title})`
        : '';

    let mrp = Math.round(item.final_price / 100);

    try {

      const productResponse = await fetch(`/products/${item.handle}.js`);
      const productData = await productResponse.json();

      const matchedVariant = productData.variants.find(
        variant => variant.id === item.variant_id
      );

      if (
        matchedVariant &&
        matchedVariant.compare_at_price
      ) {

        mrp = Math.round(
          matchedVariant.compare_at_price / 100
        );

      }

    } catch(error) {

      console.error('MRP fetch failed:', error);

    }

    const lineMrp = mrp * item.quantity;

    const sellingPrice =
      Math.round(item.final_line_price / 100);

    const savings =
      lineMrp - sellingPrice;

    totalSavings += savings;

    message += `*${item.product_title}${variant}*\n\n`;

    message += `MRP: ₹${mrp}\n`;

    message += `Qty: ${item.quantity}  |  Price: ₹${sellingPrice}\n\n`;

  }

  message += `\n`;

  message += `Total: ${this.formatMoney(cart.total_price)}\n\n`;

  message += `Savings: ₹${totalSavings}\n\n`;

  message += `Please confirm availability.`;

  return message;

}

  async sendToWhatsApp() {

    const cart = await this.fetchCart();

    if (!cart || !cart.items.length) {
      alert("Your cart is empty.");
      return;
    }

    const rawMessage = await this.generateMessage(cart);
    const encodedMessage = encodeURIComponent(rawMessage);

    const url =
    `https://wa.me/${this.phoneNumber}?text=${encodedMessage}`;

    window.open(url, '_blank');

  }

}

const whatsappCart = new WhatsAppCart();

document.addEventListener('click', function(e) {

  const button = e.target.closest('.whatsapp-checkout-button');

  if (!button) return;

  e.preventDefault();

  whatsappCart.sendToWhatsApp();

});